// extracted by mini-css-extract-plugin
export var flexLink = "training-header-module--flexLink--khsmc";
export var headerItem = "training-header-module--headerItem--Zsda-";
export var innerContainer = "training-header-module--innerContainer--LjbJz";
export var linkContainer = "training-header-module--linkContainer--PxHfI";
export var logo = "training-header-module--logo--eqCcH";
export var logoLink = "training-header-module--logoLink--ylhGp";
export var minorIcon = "training-header-module--minorIcon--xXSqT";
export var minorLink = "training-header-module--minorLink--9drwX";
export var phone = "training-header-module--phone--br52m";
export var titleItem = "training-header-module--titleItem--Gx+BT";